import React from "react";
import coatimg from "./Images/coat.jpg";
import coat2img from "./Images/coat2.png";
import deposit from "./Images/bank-svgrepo-com.svg";
import withdraw from "./Images/cash-withdraw-svgrepo-com.svg";
import moneytrans from "./Images/money-send-svgrepo-com.svg";
import online from "./Images/online-payment-svgrepo-com.svg";
import "./css/Second.css";

function Second() {
  return (
    <div className="second-page relative">
      <div className="absolute right-0 md:text-left md:pr-20 md:mt-24 text-section">
        <div className="texta md:font-bold md:text-4xl lg:text-6xl">
          Your Financial
          <br />
          Journey Begins
        </div>
        <div className="textb md:mt-4 md:text-base lg:text-lg font-normal">
          Empowering Dreams, Building Futures. Banking Beyond Boundaries
        </div>
        <div className="btn-1 md:mt-6">
          <button
            style={{
              backgroundColor: "#00a3da",
              fontWeight: "500",
            }}
          >
            Know More
          </button>
        </div>
      </div>
      <div className="coat w-full hidden md:block">
        <img src={coatimg} alt="Coat" className="w-full" />
      </div>
      <div className="coat w-full md:hidden">
        <img src={coat2img} alt="Coat" className="w-full" />
      </div>
      <div className="cards-container">
        <div className="card shadow-lg">
          <img src={deposit} alt="Bank Deposit" className="text-slate-300" />
          <div className="btxt">Bank deposit</div>
        </div>

        <div className="card shadow-lg">
          <img src={withdraw} alt="Withdraw" />
          <div className="btxt">Withdraw</div>
        </div>

        <div className="card shadow-lg">
          <img src={moneytrans} alt="Money Transfer" />
          <div className="btxt">Money transfer</div>
        </div>

        <div className="card shadow-lg">
          <img src={online} alt="Online Payment" />
          <div className="btxt">Online Payment</div>
        </div>
      </div>
    </div>
  );
}

export default Second;
